export default __webpack_public_path__ + "static/media/drMaslina.b03698af.jpg";